/**
 * Profile Messages Handling
 */
export const initMessages = (config) => {
    const container = document.querySelector('.profile-messages');
    if (!container) return;

    const bindMarkRead = (scope = container) => {
        scope.querySelectorAll('.message-item__mark-read').forEach(btn => {
            btn.addEventListener('click', async () => {
                const item = btn.closest('.message-item');
                const msgId = item.getAttribute('data-msg-id');
                const formData = new FormData();
                formData.append('action', 'united_auth_mark_read');
                formData.append('security', config.nonce);
                formData.append('id', msgId);

                try {
                    const response = await fetch(config.ajax_url, { method: 'POST', body: formData });
                    const result = await response.json();
                    if (result.success) {
                        item.classList.remove('is-unread');
                        btn.remove();
                        const badge = document.querySelector('.profile-nav__badge');
                        if (badge) {
                            const count = parseInt(badge.textContent);
                            if (count <= 1) badge.remove(); else badge.textContent = count - 1;
                        }
                    }
                } catch (err) {
                    console.error('Mark read failed:', err);
                }
            });
        });
    };

    bindMarkRead();

    // AJAX pagination delegation
    container.addEventListener('click', async (e) => {
        const pageLink = e.target.closest('.ua-pagination a.page-numbers');
        if (!pageLink) return;

        e.preventDefault();
        const url = new URL(pageLink.href, window.location.origin);
        const page = url.searchParams.get('msg_page') || 1;

        const formData = new FormData();
        formData.append('action', 'united_auth_get_messages');
        formData.append('security', config.nonce);
        formData.append('page', page);

        try {
            const response = await fetch(config.ajax_url, { method: 'POST', body: formData });
            const result = await response.json();

            if (result.success && result.data) {
                const list = container.querySelector('#profile-messages-list');
                if (list) {
                    list.innerHTML = result.data.html;
                }

                let pagWrapper = container.querySelector('.ua-pagination');
                if (result.data.pagination) {
                    if (!pagWrapper) {
                        pagWrapper = document.createElement('div');
                        pagWrapper.className = 'ua-pagination';
                        pagWrapper.dataset.collection = 'messages';
                        container.appendChild(pagWrapper);
                    }
                    pagWrapper.innerHTML = result.data.pagination;
                } else if (pagWrapper) {
                    pagWrapper.remove();
                }

                container.dataset.currentPage = result.data.current_page;
                container.dataset.totalPages = result.data.total_pages;

                bindMarkRead();
                history.pushState(null, '', pageLink.href);
            }
        } catch (err) {
            console.error('Messages pagination failed:', err);
        }
    });
};
